import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export default function TermsGate() {
  const [open, setOpen] = useState(false);
  const [ack, setAck] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("ss_token")) return;
    api.get("/auth/needs-terms").then(({ data }) => { if (data.needs) setOpen(true); }).catch(() => {});
  }, []);

  const accept = async () => {
    if (!ack) return;
    setBusy(true);
    try { await api.post("/auth/accept-terms"); setOpen(false); }
    catch { /* keep open */ } finally { setBusy(false); }
  };

  if (!open) return null;
  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent className="rounded-2xl" data-testid="terms-gate-dialog" onInteractOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle>Our Terms have been updated</DialogTitle>
          <DialogDescription>Please review and accept our latest Terms &amp; Conditions and Privacy Policy to continue using SellStuff.</DialogDescription>
        </DialogHeader>
        <label className="flex cursor-pointer items-start gap-2 text-sm text-slate-700">
          <input type="checkbox" data-testid="terms-gate-ack" checked={ack} onChange={(e) => setAck(e.target.checked)} className="mt-0.5 h-4 w-4 shrink-0" />
          <span>I agree to SellStuff's <a href="/terms" target="_blank" rel="noreferrer" className="font-semibold text-primary underline">Terms &amp; Conditions</a> and <a href="/privacy" target="_blank" rel="noreferrer" className="font-semibold text-primary underline">Privacy Policy</a>.</span>
        </label>
        <Button data-testid="terms-gate-accept" disabled={!ack || busy} onClick={accept} className="mt-2 w-full rounded-full bg-primary font-semibold">{busy ? "Saving…" : "Agree and continue"}</Button>
      </DialogContent>
    </Dialog>
  );
}
